import React,{useEffect, useState} from 'react'
import Loader from "../../../Loader/Loader";
import Header from "../../layout/header";
import BottomMenu from "../../layout/bottomMenu";
import SuccessModal from "../../CustomModal/Success";
import FailedModal from "../../CustomModal/Failed";
import FileUpload from "../../FileUploads/FileUpload";
import useLatLng from "../../../hooks/uselatlng/uselatlng";
import {toast} from "react-toastify";
import DashboardMenu from '../../layout/dashboardMenu';

const CreateTask = ({
                        documentUrlDataPublic,
                        documentUploadUrlPublic,
                        getTaskTypes,
                        taskType=[],
                        getAssignee,
                        assignee=[],
                        getAccount,
                        accountsDetails=[],
                        getOpportunityByAccountId,
                        opportunityDetails=[],
                        history,
                        saveTask,
                        saveTaskDetails=[]
                    }) => {

    const islatlng = useLatLng();
    const [isLoading, setIsLoading] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [inputList, setInputList] = useState([{
        task_id: '',
        description: '',
        assigned_to: '',
        account_id:'',
        opportunity_id:'',
        task_image: '',
        task_date:'',
        lat:'',
        long:''
    }])
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const [isAllow, setIsAllow] = useState(false);
    const [successMessage, setSuccessMessage] = useState('')
    const [accountId, setAccountId] = useState('')
    const [assignTo, setAssignedTo] = useState('')
    const [roleId, setRoleId] = useState('')

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getAssignee()
            await getTaskTypes()
            setIsLoading(false)
        })()

        setRoleId(window.localStorage.role_id)
    }, [])

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (saveTaskDetails?.status === 200) {
            setIsSuccessModalOpen(true)
            setSuccessMessage(saveTaskDetails?.message)
        } else if (saveTaskDetails?.status !== undefined && saveTaskDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setSuccessMessage(saveTaskDetails?.message)
        }
    }, [saveTaskDetails])

    useEffect(() => {
        (async () => {
            if(accountId !== ''){
                setIsLoading(true)
                await getOpportunityByAccountId(accountId)
                setIsLoading(false)
            }
        })()
    }, [accountId])

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getAccount(assignTo)
            setIsLoading(false)
        })()
    }, [assignTo])

    const handleInput = (key, val) => {
        let list = [...inputList]
        inputList[0][key] = val
        setInputList(list)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        let list =[...inputList]
        list[0]['lat'] = islatlng?.lat
        list[0]['long'] = islatlng?.lng
        if(list[0]['long'] == null || list[0]['lat'] == null){
            toast.error('Please enable your location');
            return false
        }
        setIsLoading(true)
        await saveTask(list[0])
        setIsLoading(false)
    }

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={successMessage}
                url={`task-list/1`}
            />


            <FailedModal
                isOpen={isFailedModalOpen}
                msg={successMessage}
            />

            <Loader isLoading={isLoading}/>
            <div id="wrapper">
              <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Task"}
                        />
                        {/*BODY*/}
                        <div className="container-fluid common-bg">
                            <form onSubmit={(e) => handleSubmit(e)}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-0 bg-white">
                                            <div className="card-body">
                                                <div className="user mt-4">
                                                    <div className="form-group row">

                                                        <div className="col-sm-6 mt-1 float-field" style={{marginTop:"16px !important"}}>
                                                            <select
                                                                className="form-control form-control-user"
                                                                onChange={(e) => {
                                                                    handleInput('task_id', e.target.value)
                                                                }} required>
                                                                <option value="">Select Task</option>
                                                                {taskType && taskType?.data !== undefined  && taskType?.data.map((val) => {
                                                                   return (
                                                                       <option
                                                                           value={val?.id}>{val.name}</option>
                                                                 )
                                                                })}
                                                            </select>
                                                            <label className="large-label float-lb">
                                                                Task Type <i
                                                                className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-6 mt-2 float-field d-mtk-1" style={{marginTop:"16px !important"}}>
                                                        <select
                                                            className="form-control form-control-user"
                                                            onChange={(e) => {
                                                                handleInput('assigned_to', e.target.value)
                                                                setAssignedTo(e.target.value)
                                                            }}>
                                                            <option value="">Select Assignee</option>
                                                            {assignee && assignee?.data !== undefined  && assignee?.data.map((val) => {
                                                                return (
                                                                    <option
                                                                        value={val?.id}>{val.name}</option>
                                                                )
                                                            })}
                                                        </select>
                                                        <label className="large-label float-lb">
                                                            Assign To
                                                        </label>
                                                    </div>
                                                        {parseInt(roleId) !== 42 && parseInt(roleId) !== 41 &&
                                                         <>
                                                             <div className="col-sm-6 mt-2 float-field d-mtk-2" style={{marginTop:"16px !important"}}>
                                                                 <select
                                                                     className="form-control form-control-user"
                                                                     onChange={(e) => {
                                                                         handleInput('account_id', e.target.value)
                                                                         setAccountId(e.target.value)
                                                                     }} >
                                                                     <option value="">Select Account</option>
                                                                     {accountsDetails && accountsDetails?.data !== undefined  && accountsDetails?.data.map((val) => {
                                                                         return (
                                                                             <option
                                                                                 value={val?.id}>{val.client_name !== "" && val?.client_name !== null ? val?.client_name : val?.building_name}</option>
                                                                         )
                                                                     })}
                                                                 </select>
                                                                 <label className="large-label float-lb">
                                                                     Account Name
                                                                 </label>
                                                             </div>
                                                             <div className="col-sm-6 mt-2 float-field d-mtk-2" style={{marginTop:"16px !important"}}>
                                                                 <select
                                                                     className="form-control form-control-user"
                                                                     onChange={(e) => {
                                                                         handleInput('opportunity_id', e.target.value)
                                                                     }} >
                                                                     <option value="">Select Opportunity</option>
                                                                     {opportunityDetails && opportunityDetails?.data !== undefined  && opportunityDetails?.data.map((val) => {
                                                                         return (
                                                                             <option
                                                                                 value={val?.id}>{val?.opportunity_name+" ("+val.name+")"}</option>
                                                                         )
                                                                     })}
                                                                 </select>
                                                                 <label className="large-label float-lb">
                                                                     Opportunity
                                                                 </label>
                                                             </div>
                                                         </>
                                                        }
                                                        <div className="col-sm-6 mt-2 float-field d-mtk-2">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Description*"
                                                                onChange={(e) => {
                                                                    handleInput('description', e.target.value)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                                required
                                                            />
                                                        </div>
                                                        <div className="col-sm-6 mtk-125 float-field d-mtk-2">
                                                            <input type="date"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInput('task_date', e.target.value, e)
                                                                   }}
                                                                   id="validationCustom01"
                                                                   required
                                                            />
                                                            <label className="large-label float-lb">
                                                                Task Date <i
                                                                className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-6 mtk-1 float-field mb-3">
                                                            <FileUpload
                                                                id={"addAttachment"}
                                                                accept=".png,.jpg,.jpeg"
                                                                documentUploadUrl={documentUploadUrlPublic}
                                                                documentUrlData={documentUrlDataPublic}
                                                                onChange={(val) => {
                                                                    handleInput('task_image', val)
                                                                }}
                                                                prefilledFilename={""}
                                                            >
                                                                File Attachment
                                                            </FileUpload>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-4">
                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default CreateTask